<template>
      <div class="d-flex">
        <b-form-select v-model="date.day" required :options="days" class="custom-select__day"
          @input="changeData" >
          <option :value="null" disabled>Day</option>
        </b-form-select>
        <b-form-select v-model="date.month" required :options="months" class="custom-select__month"
          @input="changeData" >
            <option :value="null" disabled>Month</option>
        </b-form-select>
        <b-form-select v-model="date.year" required :options="years" class="custom-select__year"
          @input="changeData" >
            <option :value="null" disabled>Year</option>
        </b-form-select>
      </div>
</template>

<script>
export default {
  data() {
    return {
      date: {
        day: null,
        month: null,
        monthNumber: null,
        year: null,
      },
      days: this.generateIntigersArray(1, 31),
      months: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'],
      years: this.generateIntigersArray(1900, new Date().getFullYear()),
    };
  },
  methods: {
    generateIntigersArray(from, to) {
      const arr = [];
      for (let i = from; i <= to; i += 1) {
        arr.push(i);
      }
      return arr;
    },
    daysInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    },
    isDataCorrect() {
      const isDataValid = this.date.day <= this.daysInMonth(this.date.year, this.date.monthNumber);
      return isDataValid;
    },
    changeData() {
      // Get month number
      this.date.monthNumber = (this.date.month) ? (this.months.indexOf(this.date.month) + 1) : null;
      if (this.date.day && this.date.month && this.date.year) {
        if (this.isDataCorrect()) {
          const myDataFormat = `${this.date.day}-${this.date.monthNumber}-${this.date.year}`;
          this.$emit('changeDate', myDataFormat);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/helpers/_variables.scss';
@import '../styles/helpers/_include-media.scss';

.custom-select{
  @include media('<md') {
    padding-left: 14px;
  }
  &__day {
    width: 90px;
     @include media('<xl') {
      width: 85px;
    }
    @include media('<md') {
      width: 77px;
      font-size: 14px;
    }
  }
  &__month {
    width: 125px;
     @include media('<xl') {
      width: 100px;
    }
    @include media('<md') {
      width: 80px;
      font-size: 14px;
    }
  }
  &__year {
    width: 125px;
    @include media('<xl') {
      width: 90px;
    }
    @include media('<md') {
      width: 78px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DateSelects.vue